export enum PantherColumnsAliases {
  /* eslint-disable camelcase */
  p_any_actor_ids = 'Actor IDs',
  p_any_emails = 'Emails',
  p_any_ip_addresses = 'IP Addresses',
  p_any_usernames = 'Usernames',
  p_event_time = 'Event Time',
  p_log_type = 'Log Type',
  p_parse_time = 'Parse Time',
  p_row_id = 'Row ID',
  p_schema_version = 'Schema Version',
  p_source_id = 'Log Source ID',
  p_source_label = 'Log Source Label',
  p_any_aws_account_ids = 'AWS Account IDs',
  p_any_aws_arns = 'AWS ARNs',
  p_any_aws_instance_ids = 'AWS Instance IDs',
  p_any_domain_names = 'Domain Names',
  p_any_trace_ids = 'Trace IDs',
  p_checksum = 'Checksum',
  p_current = 'Current',
  p_valid_end = 'Valid End',
  p_valid_start = 'Valid Start',
  p_alert_context = 'Alert Context',
  p_alert_creation_time = 'Alert Creation Time',
  p_alert_id = 'Alert ID',
  p_alert_severity = 'Alert Severity',
  p_alert_update_time = 'Alert Update Time',
  p_enrichment = 'Enrichment',
  p_rule_error = 'Rule Error',
  p_rule_id = 'Rule ID',
  p_rule_reports = 'Rule Reports',
  p_rule_severity = 'Rule Severity',
  p_rule_tags = 'Rule Tags',
  p_any_mac_addresses = 'MAC Addresses',
  p_any_sha1_hashes = 'SHA1 Hashes',
  p_any_aws_tags = 'AWS Tags',
  p_any_md5_hashes = 'MD5 Hashes',
  p_any_sha256_hashes = 'SHA256 Hashes',
  p_any_serial_numbers = 'Serial Numbers',
  'p_source_file.aws_s3_bucket' = 'Log Source S3 Bucket',
  'p_source_file.aws_s3_key' = 'Log Source S3 Key',
  /* eslint-enable camelcase */
}

export enum DatabaseAlias {
  'panther_rule_matches.public' = 'Rule Matches',
  'panther_logs.public' = 'Logs',
  'panther_lookups.public' = 'Lookups',
  'panther_monitor.public' = 'Monitor',
  'panther_cloudsecurity.public' = 'Cloud Security',
  'panther_rule_errors.public' = 'Rule Errors',
  'panther_signals.public' = 'Signals',
}

/**
 * returns the alias for the database key. eg: if key is `panther_signals` returns `Signals`.
 * This function handles both keys with and without a `.public` suffix.
 * if the alias is not found, returns the input key
 */
export const getDatabaseAlias = (key = '') => {
  const useKey = key ?? '';
  const lookup = useKey.endsWith('.public') ? useKey : `${useKey}.public`;
  return DatabaseAlias[lookup] ?? useKey;
};
